import templateUrl from "./timeline-list.html";

export const timelineListComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class TImelineListComponent {
    constructor(
      $state,
      toastr,
      Constants,
      AuthService,
      ModalService,
      $stateParams,
      TimelineService,
      SettingsService
    ) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.Constants = Constants;
      this.authService = AuthService;
      this.modalService = ModalService;
      this.$stateParams = $stateParams;
      this.TimelineService = TimelineService;
      this.SettingsService = SettingsService;
    }

    $onInit() {
      this.videoUrl = this.details.videoUrl || null;
      this.pageTitle = this.$state.router.globals.current.breadcrumbName;
      this._details = this.details.list.sort(function (a, b) {
        let aKey = a.sortOrder,
          bKey = b.sortOrder;
        if (aKey < bKey) return -1;
        if (aKey > bKey) return 1;
        return 0;
      });
      this.timelineDetails = {
        data: this._details,
        config: {
          defaultColumn: {
            columnName: "sortOrder", //default column name
            order: "ASC", //ASC = Ascending , DES = Descending, DEF = Default
          },
          columnDefs: [
            {
              field: "title",
              displayName: "TITLE",
              enableSort: true,
              isDownload: false,
            },
            {
              field: "noOfQuestion",
              displayName: "NO OF TASKS",
              enableSort: false,
              isDownload: false,
            },
            {
              field: "showInWebsite",
              displayName: "ACTIVE",
              type: "check",
              enableSort: false,
              isDownload: false,
            },

            {
              field: "edit",
              displayName: "",
              type: "Edit",
              enableSort: false,
            },
            {
              field: "delete",
              displayName: "",
              type: "Delete",
              enableSort: false,
            },
            {
              field: "view",
              displayName: "",
              type: "View",
              enableSort: false,
            },
          ],
        },
      };
    }
    
    onTimelineAdd() {
      if (this.pageTitle === "spouse checklist") {
        this.$state.go("spouseChecklistAdd", {});
      } else {
        this.$state.go("timelineAdd", {});
      }
    }

    onEdit(data) {
      if (this.pageTitle === "spouse checklist") {
        this.$state.go("spouseChecklistEdit", {
          id: data.id,
        });
      } else {
        this.$state.go("timelineEdit", {
          id: data.id,
        });
      }
    }

    onView(data) {
      if (this.pageTitle === "spouse checklist") {
        this.$state.go("spouseChecklistDetails", {
          id: data.id,
        });
      } else {
        this.$state.go("timelineDetails", {
          id: data.id,
        });
      }
    }

    onDelete(data) {
      let bodyMsg = data.isTimelinePerformed
        ? "There are users who have completed the task from this timeline, are you sure to delete this timeline?"
        : "Are you sure to delete this timeline?";

      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() {},
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });
      function _onDelete(data) {
        this._deleteTimeline(data.id);
      }
    }

    _deleteTimeline(id) {
      this.TimelineService.deleteNewsletter(id)
        .then((_) => {
          this.toastr.success("Newsletter deleted successfully!!");
          this.$state.reload();
        })
        .catch((err) => {
          this.toastr.error(err);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-list/timeline-list.component.js